module.exports = __webpack_public_path__ + "static/media/Live1.3741d18.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/liveroadcast/Live1.mp4
// module id = dzCn
// module chunks = 1